import type {
  AnswerDto,
  CommentDto,
  FullAnswerDto,
} from '@plugins/faq-lib/types';

export function refactorAnswerComments(answers: FullAnswerDto[]): {
  answers: AnswerDto[];
  comments: CommentDto[];
} {
  return answers.reduce(
    (acc, curr) => {
      const { comments, ...answer } = curr;
      acc.answers.push(answer);
      acc.comments = [
        ...acc.comments,
        ...comments.map((c) => ({ ...c, answer: answer.id })),
      ];
      return acc;
    },
    { answers: [] as AnswerDto[], comments: [] as CommentDto[] },
  );
}

export function isTopAnswer(answer: AnswerDto, potentialMinVotes: number) {
  return answer.correct || answer.totalUpVotes > potentialMinVotes;
}
